const dicts = {
    "abd_whs_delivery_order_type": {
        "n": "",
        "s": [
            {
                "i": 10000443,
                "c": "10",
                "n": "Pick up the goods yourself",
                "u": null
            },
            {
                "i": 10000444,
                "c": "20",
                "n": "Third Party Logistics",
                "u": null
            },
            {
                "i": 10000445,
                "c": "30",
                "n": "Cooperative logistics",
                "u": null
            }
        ],
        "i": 1042
    },
    "buyer_survey_code": {
        "n": "",
        "s": [
            {
                "i": 10000836,
                "c": "buyer_survey_question_01",
                "n": "New Client Satisfaction Survey",
                "u": null
            },
            {
                "i": 10000837,
                "c": "buyer_survey_question_02",
                "n": "Satisfaction survey for Pre-churned customer",
                "u": null
            }
        ],
        "i": 1097
    },
    "buy_buyer_bank_config": {
        "n": "",
        "s": [
            {
                "i": 10001622,
                "c": "Альфа-Банк",
                "n": "Альфа-Банк",
                "u": "https://oss.essa.cn/232a3b28-9603-4638-913e-36ec921663be.png"
            },
            {
                "i": 10001623,
                "c": "Банк ВТБ",
                "n": "Банк ВТБ",
                "u": "https://oss.essa.cn/e4708bd8-88be-4fec-ae98-f8618a2959fc.png"
            },
            {
                "i": 10001624,
                "c": "Газпромбанк",
                "n": "Газпромбанк",
                "u": "https://oss.essa.cn/ded289a1-4148-4865-9a14-c8b6ba74a52e.png"
            },
            {
                "i": 10001625,
                "c": "Промсвязьбанк",
                "n": "Промсвязьбанк",
                "u": "https://oss.essa.cn/cd3bd2cc-ba5f-46fe-aebb-b6b22c414ab5.png"
            },
            {
                "i": 10001626,
                "c": "Сбербанк",
                "n": "Сбербанк",
                "u": "https://oss.essa.cn/c5aaaa2b-1aeb-4ec2-b5a9-bfd4c7d0e978.png"
            },
            {
                "i": 10001681,
                "c": "точка банк",
                "n": "точка банк",
                "u": "http://oss.essa.cn/30d8254f-973b-4335-b7f0-999168d799f7.png"
            }
        ],
        "i": 1174
    },
    "buy_buyer_company_type": {
        "n": "",
        "s": [
            {
                "i": 911011,
                "c": "11",
                "n": "Крупный опт/дистрибьютор",
                "u": null
            },
            {
                "i": 911012,
                "c": "12",
                "n": "Мелкий опт/дистрибьютор",
                "u": null
            },
            {
                "i": 911013,
                "c": "13",
                "n": "Оптовая и розничная торговля",
                "u": null
            },
            {
                "i": 911014,
                "c": "14",
                "n": "Гипермаркет",
                "u": null
            },
            {
                "i": 911015,
                "c": "15",
                "n": "Сеть магазинов",
                "u": null
            },
            {
                "i": 911016,
                "c": "16",
                "n": "Розничная торговля/магазин",
                "u": null
            },
            {
                "i": 911017,
                "c": "17",
                "n": "Интернет-магазин",
                "u": null
            },
            {
                "i": 911018,
                "c": "18",
                "n": "Агент по закупкам",
                "u": null
            },
            {
                "i": 911019,
                "c": "19",
                "n": "Другое",
                "u": null
            }
        ],
        "i": 911
    },
    "buy_buyer_position": {
        "n": "",
        "s": [
            {
                "i": 910001,
                "c": "boss",
                "n": "Boss",
                "u": null
            },
            {
                "i": 910002,
                "c": "shareholder",
                "n": "Minority shareholder or partner",
                "u": null
            },
            {
                "i": 910003,
                "c": "purchase",
                "n": "Purchaser",
                "u": null
            },
            {
                "i": 910004,
                "c": "other",
                "n": "Other",
                "u": null
            }
        ],
        "i": 910
    },
    "buy_buyer_sales_amount": {
        "n": "",
        "s": [
            {
                "i": 915001,
                "c": "0",
                "n": "130000 USD",
                "u": null
            },
            {
                "i": 915002,
                "c": "1",
                "n": "130 000 -- 400 000 USD",
                "u": null
            },
            {
                "i": 915003,
                "c": "2",
                "n": "400 000 - 660 000 USD",
                "u": null
            },
            {
                "i": 915004,
                "c": "3",
                "n": "660 000 - 130 0 000 USD",
                "u": null
            },
            {
                "i": 915005,
                "c": "4",
                "n": "1300 000 -- 2630 000 USD",
                "u": null
            },
            {
                "i": 915006,
                "c": "5",
                "n": "Above 2630 000 USD",
                "u": null
            }
        ],
        "i": 915
    },
    "buy_buyer_sales_channels": {
        "n": "",
        "s": [
            {
                "i": 912001,
                "c": "offline_store",
                "n": "Offline store",
                "u": null
            },
            {
                "i": 912002,
                "c": "internet_sales",
                "n": "Online sale",
                "u": null
            },
            {
                "i": 912003,
                "c": "all",
                "n": "Offline Store & Sell Online",
                "u": null
            }
        ],
        "i": 912
    },
    "buy_buyer_sales_sku": {
        "n": "",
        "s": [
            {
                "i": 914001,
                "c": "0",
                "n": "Below 500",
                "u": null
            },
            {
                "i": 914002,
                "c": "1",
                "n": "500 - 1 000",
                "u": null
            },
            {
                "i": 914003,
                "c": "2",
                "n": "1 000–3 000",
                "u": null
            },
            {
                "i": 914004,
                "c": "3",
                "n": "3 000-5 000",
                "u": null
            },
            {
                "i": 914005,
                "c": "4",
                "n": "Above 5000",
                "u": null
            }
        ],
        "i": 914
    },
    "buy_customer_intent_level": {
        "n": "",
        "s": [
            {
                "i": 717001,
                "c": "1",
                "n": "C",
                "u": null
            },
            {
                "i": 717002,
                "c": "2",
                "n": "B",
                "u": null
            },
            {
                "i": 717003,
                "c": "3",
                "n": "A",
                "u": null
            }
        ],
        "i": 717
    },
    "claim_demage_order_damage_code": {
        "n": "",
        "s": [
            {
                "i": 927001,
                "c": "quantity",
                "n": "Lack of goods quantity",
                "u": null
            },
            {
                "i": 927002,
                "c": "parts",
                "n": "Lack of goods accessories",
                "u": null
            },
            {
                "i": 927003,
                "c": "colour",
                "n": "Color or quantity of goods does not match the order",
                "u": null
            },
            {
                "i": 927004,
                "c": "goods_bad",
                "n": "The goods is broken",
                "u": null
            },
            {
                "i": 927005,
                "c": "package_bad",
                "n": "Packaging is broken",
                "u": null
            },
            {
                "i": 927006,
                "c": "wrong_delivery",
                "n": "Factory sent wrong goods",
                "u": null
            }
        ],
        "i": 927
    },
    "claim_demage_order_fin_handle_status": {
        "n": "",
        "s": [
            {
                "i": 928001,
                "c": "to_de_handle",
                "n": "In process",
                "u": null
            },
            {
                "i": 928002,
                "c": "handled",
                "n": "Processed",
                "u": null
            }
        ],
        "i": 928
    },
    "claim_demage_order_status": {
        "n": "",
        "s": [
            {
                "i": 923001,
                "c": "1",
                "n": "Verifying",
                "u": null
            },
            {
                "i": 10000485,
                "c": "7",
                "n": "Pending processing",
                "u": null
            },
            {
                "i": 10000486,
                "c": "8",
                "n": "Closed",
                "u": null
            },
            {
                "i": 923002,
                "c": "2",
                "n": "Processing",
                "u": null
            },
            {
                "i": 923003,
                "c": "3",
                "n": "Rejected",
                "u": null
            },
            {
                "i": 923004,
                "c": "4",
                "n": "Revoked",
                "u": null
            },
            {
                "i": 923005,
                "c": "5",
                "n": "Compensated",
                "u": null
            },
            {
                "i": 923006,
                "c": "6",
                "n": "Invalid",
                "u": null
            }
        ],
        "i": 923
    },
    "claim_demage_order_status_mg": {
        "n": "",
        "s": [
            {
                "i": 10000476,
                "c": "1",
                "n": "Pending processing",
                "u": null
            },
            {
                "i": 10000478,
                "c": "3",
                "n": "Rejected",
                "u": null
            },
            {
                "i": 10000480,
                "c": "5",
                "n": "Compensated",
                "u": null
            },
            {
                "i": 10000482,
                "c": "7",
                "n": "Pending payment",
                "u": null
            },
            {
                "i": 10000477,
                "c": "2",
                "n": "Approved",
                "u": null
            },
            {
                "i": 10000479,
                "c": "4",
                "n": "Cancelled",
                "u": null
            },
            {
                "i": 10000481,
                "c": "6",
                "n": "Expired",
                "u": null
            },
            {
                "i": 10000483,
                "c": "8",
                "n": "Closed",
                "u": null
            },
            {
                "i": 10000484,
                "c": "9",
                "n": "Initiated",
                "u": null
            }
        ],
        "i": 1048
    },
    "claim_demage_order_type": {
        "n": "",
        "s": [
            {
                "i": 924001,
                "c": "arrive_late",
                "n": "Shipping Guarantee",
                "u": null
            },
            {
                "i": 924002,
                "c": "damaged",
                "n": "Quality Guarantee",
                "u": null
            },
            {
                "i": 924003,
                "c": "disable",
                "n": "Best Price Guarantee",
                "u": null
            }
        ],
        "i": 924
    },
    "ddp_abd_buyer_storage_status": {
        "n": "",
        "s": [
            {
                "i": 4680195,
                "c": "10",
                "n": "未付款",
                "u": null
            },
            {
                "i": 4680196,
                "c": "20",
                "n": "部分付款",
                "u": null
            },
            {
                "i": 4680197,
                "c": "30",
                "n": "待出库",
                "u": null
            }
        ],
        "i": 948
    },
    "ddp_sticker_tort_remark": {
        "n": "",
        "s": [
            {
                "i": 1018001,
                "c": "1",
                "n": "Commodity infringement",
                "u": null
            },
            {
                "i": 1018002,
                "c": "2",
                "n": "Trademark infringement",
                "u": null
            },
            {
                "i": 1018003,
                "c": "3",
                "n": "Combination infringement of registered colors",
                "u": null
            },
            {
                "i": 1018004,
                "c": "4",
                "n": "Inscription font infringement",
                "u": null
            }
        ],
        "i": 1018
    },
    "essaone_buyer_label_type": {
        "n": "",
        "s": [
            {
                "i": 10000783,
                "c": "10",
                "n": "New customer",
                "u": null
            },
            {
                "i": 10000784,
                "c": "20",
                "n": "Growth customer",
                "u": null
            },
            {
                "i": 10000785,
                "c": "30",
                "n": "Retained customer",
                "u": null
            },
            {
                "i": 10000786,
                "c": "40",
                "n": "Pre-churned customer",
                "u": null
            },
            {
                "i": 10000787,
                "c": "50",
                "n": "Churned customers",
                "u": null
            }
        ],
        "i": 1086
    },
    "essaone_new_buyer_label_type": {
        "n": "",
        "s": [
            {
                "i": 10000788,
                "c": "10",
                "n": "Waiting for initial contact",
                "u": null
            },
            {
                "i": 10000904,
                "c": "80",
                "n": "Reactivation",
                "u": null
            },
            {
                "i": 10000789,
                "c": "20",
                "n": "Keep in touch(Target Customers)",
                "u": null
            },
            {
                "i": 10000790,
                "c": "21",
                "n": "Keep in touch(Non-target customer)",
                "u": null
            },
            {
                "i": 10000791,
                "c": "30",
                "n": "Add to Purchase",
                "u": null
            },
            {
                "i": 10000792,
                "c": "40",
                "n": "First order",
                "u": null
            },
            {
                "i": 10000793,
                "c": "50",
                "n": "Successful transaction",
                "u": null
            },
            {
                "i": 10000794,
                "c": "60",
                "n": "Failed transaction",
                "u": null
            },
            {
                "i": 10000795,
                "c": "70",
                "n": "Follow-up failure",
                "u": null
            }
        ],
        "i": 1087
    },
    "essaone_not_transacted_reason_type": {
        "n": "",
        "s": [
            {
                "i": 10000815,
                "c": "10",
                "n": "No need. We've changed our minds and are holding off for now.",
                "u": null
            },
            {
                "i": 10000816,
                "c": "20",
                "n": "It's expensive.",
                "u": null
            },
            {
                "i": 10000817,
                "c": "30",
                "n": "Switch to a competitor",
                "u": null
            },
            {
                "i": 10000818,
                "c": "40",
                "n": "Decision to postpone purchase",
                "u": null
            },
            {
                "i": 10000819,
                "c": "50",
                "n": "Other reasons",
                "u": null
            }
        ],
        "i": 1093
    },
    "fin_refund_from_type": {
        "n": "",
        "s": [
            {
                "i": 925001,
                "c": "arrive_late",
                "n": "Shipping Guarantee",
                "u": null
            },
            {
                "i": 925005,
                "c": "title_to_goods",
                "n": "Waiver of Goods Ownership",
                "u": null
            },
            {
                "i": 925006,
                "c": "cash_out",
                "n": "Customer Withdrawal",
                "u": null
            },
            {
                "i": 925002,
                "c": "damaged",
                "n": "Quality Guarantee",
                "u": null
            },
            {
                "i": 925003,
                "c": "disable",
                "n": "Best Price Guarantee",
                "u": null
            },
            {
                "i": 925004,
                "c": "goods_cancel",
                "n": "Goods cancelled",
                "u": null
            }
        ],
        "i": 925
    },
    "fin_remittance_item_pay_type": {
        "n": "",
        "s": [
            {
                "i": 500002,
                "c": "LETTER_OF_CREDIT",
                "n": "Letter of credit",
                "u": null
            },
            {
                "i": 500004,
                "c": "CASH",
                "n": "Cash",
                "u": null
            }
        ],
        "i": 500
    },
    "fx_commission_wallet_item_biz_type": {
        "n": "",
        "s": [
            {
                "i": 997001,
                "c": "BUYER",
                "n": "Invited customers",
                "u": null
            },
            {
                "i": 997002,
                "c": "DISTRIBUTOR_BUYER",
                "n": "Customers invited by distributors",
                "u": null
            },
            {
                "i": 997003,
                "c": "ORDER",
                "n": "Order Rewards",
                "u": null
            },
            {
                "i": 997004,
                "c": "OTHER",
                "n": "Other",
                "u": null
            },
            {
                "i": 997005,
                "c": "WITHDRAW",
                "n": "Withdraw cash",
                "u": null
            }
        ],
        "i": 997
    },
    "fx_invitation_buyer_status": {
        "n": "",
        "s": [
            {
                "i": 10000001,
                "c": "0",
                "n": "Authentication in progress",
                "u": null
            },
            {
                "i": 10000002,
                "c": "1",
                "n": "Authentication failed",
                "u": null
            },
            {
                "i": 10000003,
                "c": "2",
                "n": "Authenticated",
                "u": null
            }
        ],
        "i": 1000
    },
    "fx_user_status": {
        "n": "",
        "s": [
            {
                "i": 816001,
                "c": "VALID",
                "n": "Enabled",
                "u": null
            },
            {
                "i": 816002,
                "c": "INVALID",
                "n": "Deactivated",
                "u": null
            },
            {
                "i": 816003,
                "c": "NOT_ENABLED",
                "n": "Not activated",
                "u": null
            }
        ],
        "i": 816
    },
    "fx_user_type": {
        "n": "",
        "s": [
            {
                "i": 908001,
                "c": "0",
                "n": "Commission by registration",
                "u": null
            },
            {
                "i": 908002,
                "c": "1",
                "n": "Commission by order",
                "u": null
            }
        ],
        "i": 908
    },
    "im_type": {
        "n": "",
        "s": [
            {
                "i": 372,
                "c": "2",
                "n": "whatsapp",
                "u": null
            },
            {
                "i": 373,
                "c": "3",
                "n": "skype",
                "u": null
            },
            {
                "i": 374,
                "c": "4",
                "n": "wechat",
                "u": null
            },
            {
                "i": 375,
                "c": "5",
                "n": "Email",
                "u": null
            },
            {
                "i": 377,
                "c": "7",
                "n": "cell phone",
                "u": null
            },
            {
                "i": 380,
                "c": "10",
                "n": "Facebook",
                "u": null
            },
            {
                "i": 396,
                "c": "11",
                "n": "Twitter",
                "u": null
            },
            {
                "i": 10000649,
                "c": "13",
                "n": "LinkedIn",
                "u": null
            },
            {
                "i": 10000650,
                "c": "14",
                "n": "Line",
                "u": null
            },
            {
                "i": 10000651,
                "c": "15",
                "n": "Telegram",
                "u": null
            },
            {
                "i": 10000704,
                "c": "16",
                "n": "vkontakte",
                "u": null
            }
        ],
        "i": 46
    },
    "is_corporate_enterprise": {
        "n": "",
        "s": [
            {
                "i": 10000796,
                "c": "0",
                "n": "No",
                "u": null
            },
            {
                "i": 10000797,
                "c": "1",
                "n": "Yes",
                "u": null
            }
        ],
        "i": 1088
    },
    "is_ka_buyer": {
        "n": "",
        "s": [
            {
                "i": 10000800,
                "c": "0",
                "n": "Non-KA",
                "u": null
            },
            {
                "i": 10000801,
                "c": "1",
                "n": "KA",
                "u": null
            }
        ],
        "i": 1090
    },
    "is_one_box": {
        "n": "",
        "s": [
            {
                "i": 10000798,
                "c": "0",
                "n": "No",
                "u": null
            },
            {
                "i": 10000799,
                "c": "1",
                "n": "Yes",
                "u": null
            }
        ],
        "i": 1089
    },
    "po_item_sticker_icon_code": {
        "n": "",
        "s": [
            {
                "i": 10001045,
                "c": "01",
                "n": "eac",
                "u": "https://oss.essa.cn/sticker_icon_01.png"
            },
            {
                "i": 10001046,
                "c": "002",
                "n": "易碎品",
                "u": "https://oss.essa.cn/sticker_icon_02.png"
            },
            {
                "i": 10001047,
                "c": "003",
                "n": "PVC03",
                "u": "https://oss.essa.cn/sticker_icon_03.png"
            },
            {
                "i": 10001048,
                "c": "004",
                "n": "PAP20",
                "u": "https://oss.essa.cn/sticker_icon_04.png"
            },
            {
                "i": 10001049,
                "c": "005",
                "n": "可扔垃圾桶",
                "u": "https://oss.essa.cn/sticker_icon_05.png"
            },
            {
                "i": 10001050,
                "c": "006",
                "n": "PE-LD04",
                "u": "https://oss.essa.cn/sticker_icon_06.png"
            },
            {
                "i": 10001051,
                "c": "007",
                "n": "可回收",
                "u": "https://oss.essa.cn/sticker_icon_07.png"
            },
            {
                "i": 10001671,
                "c": "008",
                "n": "PET01",
                "u": "https://oss.essa.cn/8f09badc-49f9-46fb-9fdc-0fc83428f34f.jpg"
            },
            {
                "i": 10001672,
                "c": "009",
                "n": "PAP21",
                "u": "https://oss.essa.cn/fa6bdea8-0349-44a4-87cc-5abfbd018a5b.png"
            },
            {
                "i": 10001673,
                "c": "010",
                "n": "PAP22",
                "u": "https://oss.essa.cn/bd2ef938-640c-4410-8b44-5fa1db7afd28.png"
            },
            {
                "i": 10001674,
                "c": "011",
                "n": "PP05",
                "u": "https://oss.essa.cn/656e99f1-25b3-402f-b7c7-2507223b75e5.png"
            },
            {
                "i": 10001675,
                "c": "PC",
                "n": "PC",
                "u": "https:////oss.essa.cn/903b133d-22de-49f1-a8a1-15e124687518.png"
            },
            {
                "i": 10001676,
                "c": "FOR51",
                "n": "FOR51",
                "u": "https:////oss.essa.cn/1ba5f48e-92ba-4b29-a20d-7220d162de78.png"
            },
            {
                "i": 10001677,
                "c": "ALU41",
                "n": "ALU41",
                "u": "https:////oss.essa.cn/3f9d9de2-158c-4fd9-929b-69d96af322bb.png"
            }
        ],
        "i": 1158
    },
    "prd_goods_copyright": {
        "n": "",
        "s": [
            {
                "i": 107001,
                "c": "1",
                "n": "Own the copyright",
                "u": null
            },
            {
                "i": 107002,
                "c": "2",
                "n": "Third-party copyright",
                "u": null
            },
            {
                "i": 107003,
                "c": "3",
                "n": "No authorization",
                "u": null
            },
            {
                "i": 107004,
                "c": "4",
                "n": "A cargo",
                "u": null
            }
        ],
        "i": 107
    },
    "prd_goods_out_box_unit": {
        "n": "",
        "s": [
            {
                "i": 108010,
                "c": "10",
                "n": "Box",
                "u": null
            }
        ],
        "i": 108
    },
    "sale_po_claim_demage_order_claim_type": {
        "n": "",
        "s": [
            {
                "i": 10000474,
                "c": "10",
                "n": "Coupon",
                "u": null
            },
            {
                "i": 10000475,
                "c": "20",
                "n": " Cash",
                "u": null
            }
        ],
        "i": 1047
    },
    "sale_po_ddp_status_buyer": {
        "n": "",
        "s": [
            {
                "i": 1000398,
                "c": "-10",
                "n": "Canceled",
                "u": null
            },
            {
                "i": 1000399,
                "c": "10",
                "n": "Deposit to pay",
                "u": null
            },
            {
                "i": 1000401,
                "c": "20",
                "n": "Deposit paid, order in process",
                "u": null
            },
            {
                "i": 1000402,
                "c": "40",
                "n": "Orders in production",
                "u": null
            },
            {
                "i": 1000413,
                "c": "41",
                "n": "Production has been completed.",
                "u": null
            },
            {
                "i": 1000403,
                "c": "45",
                "n": "On the quality control",
                "u": null
            },
            {
                "i": 1000404,
                "c": "50",
                "n": "On the way",
                "u": null
            },
            {
                "i": 1000405,
                "c": "60",
                "n": "Loading container",
                "u": null
            },
            {
                "i": 1000406,
                "c": "70",
                "n": "Loading is complete",
                "u": null
            },
            {
                "i": 1000407,
                "c": "80",
                "n": "Custome check is over",
                "u": null
            },
            {
                "i": 1000408,
                "c": "90",
                "n": "Goods have been shipped, waiting for the payment.",
                "u": null
            },
            {
                "i": 1000414,
                "c": "100",
                "n": "The balance to be paid",
                "u": null
            },
            {
                "i": 1000415,
                "c": "105",
                "n": "The balance has been paid, waiting to be picked up",
                "u": null
            },
            {
                "i": 1000400,
                "c": "110",
                "n": "Order is complete",
                "u": null
            },
            {
                "i": 4680243,
                "c": "101",
                "n": "The balance has been paid",
                "u": null
            },
            {
                "i": 4680244,
                "c": "102",
                "n": "In storage, pending final payment",
                "u": null
            },
            {
                "i": 4680245,
                "c": "106",
                "n": "Arrived in  the warehouse, waiting to be picked up",
                "u": null
            },
            {
                "i": 10001715,
                "c": "107",
                "n": "Processing Chestny Znak",
                "u": null
            }
        ],
        "i": 931
    },
    "sale_po_ddp_status_buyer_activity": {
        "n": "",
        "s": [
            {
                "i": 4680190,
                "c": "-10",
                "n": "Canceled",
                "u": null
            },
            {
                "i": 4680191,
                "c": "10",
                "n": "Pending Payment",
                "u": null
            },
            {
                "i": 4680192,
                "c": "105",
                "n": "Paid, pending pickup",
                "u": null
            },
            {
                "i": 4680193,
                "c": "110",
                "n": "Completed",
                "u": null
            }
        ],
        "i": 947
    },
    "sale_po_status": {
        "n": "",
        "s": [
            {
                "i": 300001,
                "c": "-10",
                "n": "Canceled",
                "u": null
            },
            {
                "i": 4680194,
                "c": "105",
                "n": "已入库",
                "u": null
            },
            {
                "i": 10000636,
                "c": "5",
                "n": "Awaiting Consolidation",
                "u": null
            },
            {
                "i": 300002,
                "c": "10",
                "n": "Deposit to pay",
                "u": null
            },
            {
                "i": 300010,
                "c": "90",
                "n": "In transit",
                "u": null
            },
            {
                "i": 300012,
                "c": "110",
                "n": "Completes",
                "u": null
            }
        ],
        "i": 300
    },
    "sale_po_status_buyer": {
        "n": "",
        "s": [
            {
                "i": 454001,
                "c": "-10",
                "n": "Canceled",
                "u": null
            },
            {
                "i": 10000637,
                "c": "5",
                "n": "Awaiting Loading into Container",
                "u": null
            },
            {
                "i": 454002,
                "c": "10",
                "n": "Deposit to pay",
                "u": null
            },
            {
                "i": 454003,
                "c": "20",
                "n": "In placing order",
                "u": null
            },
            {
                "i": 454004,
                "c": "40",
                "n": "In the production",
                "u": null
            },
            {
                "i": 454005,
                "c": "45",
                "n": "On the quality control",
                "u": null
            },
            {
                "i": 454006,
                "c": "50",
                "n": "On the way",
                "u": null
            },
            {
                "i": 454007,
                "c": "60",
                "n": "Loading container",
                "u": null
            },
            {
                "i": 454008,
                "c": "70",
                "n": "Loading is complete",
                "u": null
            },
            {
                "i": 454009,
                "c": "80",
                "n": "Custome check is over",
                "u": null
            },
            {
                "i": 454010,
                "c": "90",
                "n": "Goods have been shipped",
                "u": null
            },
            {
                "i": 454012,
                "c": "110",
                "n": "Order is complete",
                "u": null
            }
        ],
        "i": 454
    },
    "sale_type": {
        "n": "",
        "s": [
            {
                "i": 107,
                "c": "2",
                "n": "Act as agent",
                "u": null
            }
        ],
        "i": 23
    },
    "sup_certification_type": {
        "n": "",
        "s": [
            {
                "i": 115001,
                "c": "CCC",
                "n": "CCC",
                "u": null
            },
            {
                "i": 115002,
                "c": "10P",
                "n": "10P",
                "u": null
            },
            {
                "i": 115003,
                "c": "13P",
                "n": "13P",
                "u": null
            },
            {
                "i": 115004,
                "c": "3P",
                "n": "3P",
                "u": null
            },
            {
                "i": 115005,
                "c": "6P",
                "n": "6P",
                "u": null
            },
            {
                "i": 115006,
                "c": "7P",
                "n": "7P",
                "u": null
            },
            {
                "i": 115007,
                "c": "8P",
                "n": "8P",
                "u": null
            },
            {
                "i": 115008,
                "c": "9P",
                "n": "9P",
                "u": null
            },
            {
                "i": 115009,
                "c": "ASTM_F963",
                "n": "ASTM-F963",
                "u": null
            },
            {
                "i": 115010,
                "c": "AZO",
                "n": "AZO",
                "u": null
            },
            {
                "i": 115011,
                "c": "CD",
                "n": "CD",
                "u": null
            },
            {
                "i": 115012,
                "c": "CE",
                "n": "CE",
                "u": null
            },
            {
                "i": 115013,
                "c": "C_TPAT",
                "n": "C-TPAT",
                "u": null
            },
            {
                "i": 115014,
                "c": "EMC",
                "n": "EMC",
                "u": null
            },
            {
                "i": 115015,
                "c": "EN60825",
                "n": "EN60825",
                "u": null
            },
            {
                "i": 115016,
                "c": "EN62115",
                "n": "EN62115",
                "u": null
            },
            {
                "i": 115017,
                "c": "EN71",
                "n": "EN71",
                "u": null
            },
            {
                "i": 115018,
                "c": "FCC",
                "n": "FCC",
                "u": null
            },
            {
                "i": 115019,
                "c": "GB19865",
                "n": "GB19865",
                "u": null
            },
            {
                "i": 115020,
                "c": "GB6675",
                "n": "GB6675",
                "u": null
            },
            {
                "i": 115021,
                "c": "GS",
                "n": "GS",
                "u": null
            },
            {
                "i": 115022,
                "c": "HR4040_CPSIA",
                "n": "HR4040/CPSIA",
                "u": null
            },
            {
                "i": 115023,
                "c": "ICTI",
                "n": "ICTI",
                "u": null
            },
            {
                "i": 115024,
                "c": "IEC60825",
                "n": "IEC60825",
                "u": null
            },
            {
                "i": 115025,
                "c": "ILAC",
                "n": "ILAC",
                "u": null
            },
            {
                "i": 115026,
                "c": "ISO8124",
                "n": "ISO8124",
                "u": null
            },
            {
                "i": 115027,
                "c": "PB",
                "n": "PB",
                "u": null
            },
            {
                "i": 115028,
                "c": "PHTHALATES",
                "n": "PHTHALATES",
                "u": null
            },
            {
                "i": 115029,
                "c": "R_TTE",
                "n": "R&TTE",
                "u": null
            },
            {
                "i": 115030,
                "c": "REACH",
                "n": "REACH",
                "u": null
            },
            {
                "i": 115031,
                "c": "ROHS",
                "n": "ROHS",
                "u": null
            },
            {
                "i": 115032,
                "c": "SGS",
                "n": "SGS",
                "u": null
            },
            {
                "i": 115033,
                "c": "UK",
                "n": "UK certificate",
                "u": null
            },
            {
                "i": 115034,
                "c": "USP51",
                "n": "USP51",
                "u": null
            },
            {
                "i": 115035,
                "c": "USP61_62",
                "n": "USP61.62",
                "u": null
            },
            {
                "i": 1000236,
                "c": "PAHS",
                "n": "PAHS",
                "u": null
            },
            {
                "i": 1000237,
                "c": "EN62471",
                "n": "EN62471",
                "u": null
            },
            {
                "i": 1000238,
                "c": "BIS",
                "n": "BIS",
                "u": null
            },
            {
                "i": 1000241,
                "c": "GCC",
                "n": "GCC",
                "u": null
            },
            {
                "i": 1000366,
                "c": "CPC",
                "n": "CPC",
                "u": null
            },
            {
                "i": 4680342,
                "c": "SCCP",
                "n": "SCCP",
                "u": null
            },
            {
                "i": 4680343,
                "c": "CPSC",
                "n": "CPSC",
                "u": null
            },
            {
                "i": 4680344,
                "c": "SVHC",
                "n": "SVHC",
                "u": null
            },
            {
                "i": 4680345,
                "c": "California_65",
                "n": "California 65",
                "u": null
            },
            {
                "i": 4680346,
                "c": "Hexaphenylbenzene",
                "n": "Hexaphenylbenzene",
                "u": null
            },
            {
                "i": 4680347,
                "c": "EU_total_cadmium",
                "n": "欧盟总镉",
                "u": null
            }
        ],
        "i": 115
    },
    "unit_type": {
        "n": "",
        "s": [
            {
                "i": 699001,
                "c": "he",
                "n": "pcs",
                "u": null
            },
            {
                "i": 699002,
                "c": "dai",
                "n": "pcs",
                "u": null
            },
            {
                "i": 699003,
                "c": "nx",
                "n": "Inner box",
                "u": null
            },
            {
                "i": 699004,
                "c": "wx",
                "n": "ctn",
                "u": null
            },
            {
                "i": 699005,
                "c": "ban",
                "n": "pcs",
                "u": null
            },
            {
                "i": 699006,
                "c": "TONG",
                "n": "pcs",
                "u": null
            },
            {
                "i": 699007,
                "c": "bao",
                "n": "PCS",
                "u": null
            },
            {
                "i": 699008,
                "c": "pian",
                "n": "PCS",
                "u": null
            },
            {
                "i": 699009,
                "c": "ka",
                "n": "PCS",
                "u": null
            },
            {
                "i": 699010,
                "c": "tiao",
                "n": "PCS",
                "u": null
            },
            {
                "i": 699011,
                "c": "PCS",
                "n": "PCS",
                "u": null
            },
            {
                "i": 699012,
                "c": "guan",
                "n": "PCS",
                "u": null
            },
            {
                "i": 699013,
                "c": "jia",
                "n": "pcs",
                "u": null
            },
            {
                "i": 699014,
                "c": "lan",
                "n": "Blue",
                "u": null
            },
            {
                "i": 699015,
                "c": "ton",
                "n": "шт.",
                "u": null
            },
            {
                "i": 699016,
                "c": "zhao",
                "n": "PCS",
                "u": null
            },
            {
                "i": 10001679,
                "c": "ge",
                "n": "pcs",
                "u": null
            },
            {
                "i": 10001657,
                "c": "tao",
                "n": "pcs",
                "u": null
            }
        ],
        "i": 699
    },
    "wallet_withdraw_item_handle_remark_code": {
        "n": "",
        "s": [
            {
                "i": 999001,
                "c": "10",
                "n": "Bank account information is incorrect and cannot be settled",
                "u": null
            },
            {
                "i": 999002,
                "c": "20",
                "n": "The application is rejected by consensus.",
                "u": null
            }
        ],
        "i": 999
    }
}
 export default dicts;